module.exports = __webpack_public_path__ + "img/marketo.b9ac2d82.png";